import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll2(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("vbIncomingDocInBookView", {params: params});
  },

  findAll(usingAdvanceSearch, keyword, bookId, form, pageable, fromDocDate, toDocDate) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      utils.merge(
        {
          usingAdvanceSearch: usingAdvanceSearch,
          keyword: keyword,
          bookId: bookId,
          fromDocDate: fromDocDate,
          toDocDate: toDocDate
        },
        form
      ),
      pageable
    );

    return httpService.get("vbIncomingDocInBookView", {params: params});
  },

  count(usingAdvanceSearch, keyword, bookId, form, fromDocDate, toDocDate) {
    let params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        bookId: bookId,
        fromDocDate: fromDocDate,
        toDocDate: toDocDate
      },
      form
    );

    return httpService.get("vbIncomingDocInBookView/count", {params: params});
  }
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingDocInBookViewService.js